import './modules/fileupload'

(async () => {
  //validation
  const forms = document.querySelectorAll('.needs-validation')

  const isApplicationForm = document.querySelector('#applicationContactForm');
  const isTechSupportForm = document.querySelector('#techSupportForm')

  if (isApplicationForm) {
    const countries = await getCountries()

    const countrySelect = document.getElementById('country-select');
    countries.sort((a, b) => a.name.common.localeCompare(b.name.common))
    countries.forEach(c => {
      var opt = document.createElement('option');
      opt.value = c.cca2;
      opt.innerHTML = c.name.common;
      countrySelect.appendChild(opt);
    })

    countrySelect.addEventListener('change', (e) => {
      const countryCCA = e.target.value;
      const item = countries.filter(item => item.cca2.includes(countryCCA));
      const callingCode = item[0].callingCodes[0] || '';
      document.getElementById('tel-prefix').innerHTML = callingCode
      document.getElementById('prefix').value = callingCode
    })
  }


  Array.from(forms).forEach(form => {
    const btn = document.querySelector(`${form.target} #form-button`)
    const btnContainer = document.querySelector(`${form.target} .send-btn-container`)

    btn.addEventListener('click', event => {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
      } else if (form.checkValidity()) {
        setBtnStatus(btnContainer, 'Sending')

        grecaptcha.ready(function () {
          grecaptcha.execute('6Lfa2P8UAAAAABC6DlDHvyzoW7xhzeCgb5zoPaY4', { action: 'submit' }).then(function (token) {
            if (isApplicationForm) {
              const formData = new FormData(form);
              const data = Array.from(formData.entries()).reduce((memo, [key, value]) => ({
                ...memo,
                [key]: value,
              }), {});

              data.telephone = `${data.prefix}${data.telephone}`
              delete data.prefix

              data.token = token

              fetch('/app/contact-forms/application', {
                method: "POST",
                body: JSON.stringify(data)
              })
                .then(res => {
                  if (res.ok) {
                    window.location = "/contact/thanks"
                  } else {
                    setBtnStatus(btn, 'Send')
                    document.querySelector('.error-message').style.display = 'block';
                  }
                })
            } else if (isTechSupportForm) {
              const formData = new FormData(form)
              formData.append('token', token);

              fetch('/app/contact-forms/tech', {
                method: "POST",
                body: formData
              })
                .then(res => {
                  if (res.ok) {
                    window.location = "/contact/thanks"
                  } else {
                    setBtnStatus(btn, 'Send')
                    document.querySelector('.error-message').style.display = 'block';
                  }
                })
            }
          });

        });
      }
      form.classList.add('was-validated')
    }, false)
  })
})()

async function getCountries() {
  const response = await fetch("/global/data/countries.json");
  return await response.json();
}

function setBtnStatus(btnContainer, action) {
  console.log(btnContainer)
  console.log(action)
  debugger
  if (action === 'Sending') {
    btnContainer.classList.add('spinner')
    btnContainer.querySelector('button').innerHTML = action
    btnContainer.querySelector('button').disabled = true;
  } else {
    btnContainer.classList.remove('spinner')
    btnContainer.querySelector('button').innerHTML = action
    btnContainer.querySelector('button').disabled = false;
  }
}